// Prevent accidental browser back button
const preventBrowserBackButton = ({ next, showDialog, message = "Do you really want to leave? You have unsaved changes." }) => {
	if (!showDialog) {
		next()
		return
	}

	// Show browser dialog
	const answer = window.confirm(message)
	if (answer) next()
	else next(false)
}

export { preventBrowserBackButton }
